import { Transition, Dialog } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

export type ModalProps = {
    children: ReactNode;
    isOpen: boolean;
    onClose: () => void;
};

function Modal({ children, isOpen, onClose }: ModalProps): JSX.Element {
    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className="fixed z-[60] inset-0 overflow-y-auto" onClose={onClose}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-200"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-100"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="transform transition-all inline-block align-middle overflow-hidden shadow-xl w-max">
                            <div className="bg-white rounded-lg">{children}</div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default Modal;

// import { Fragment, ReactNode, useEffect, useState } from 'react';
// import { Dialog, Transition } from '@headlessui/react';

// import { getChildrenByType } from '../../utils';
// import Button from '../button/Button';

// const styles = {
//     icon: {
//         base: 'mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full',
//         info: 'text-blue-600 bg-blue-100',
//         success: 'text-green-600 bg-green-100',
//         warning: 'text-yellow-600 bg-yellow-100',
//         error: 'text-red-600 bg-red-100',
//     },
// };

// type ModalProps = {
//     isOpen: boolean;
//     onClose?: () => void;
//     type?: 'info' | 'success' | 'warning' | 'error';
//     center?: boolean;
//     children: ReactNode[];
// };

// type IconProps = {
//     type: 'info' | 'success' | 'warning' | 'error';
// };

// type TitleProps = {
//     children: string;
// };

// type BodyProps = {
//     children: string;
// };

// type FooterProps = {
//     children: ReactNode | ReactNode[];
// };

// const icons = {
//     info: <InformationCircleIcon className="h-6 w-6" aria-hidden="true" />,
//     success: <CheckIcon className="h-6 w-6" aria-hidden="true" />,
//     warning: <ExclamationIcon className="h-6 w-6" aria-hidden="true" />,
//     error: <XIcon className="h-6 w-6" aria-hidden="true" />,
// };

// function Modal({ isOpen, onClose, children, type, center = false }: ModalProps): JSX.Element {
//     const [open, setOpen] = useState(isOpen);

//     useEffect(() => {
//         setOpen(isOpen);
//     }, [isOpen]);

//     if (!isOpen) {
//         return null;
//     }
//     return (
//         <Transition.Root show={open} as={Fragment}>
//             <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={setOpen}>
//                 <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
//                     <Backdrop />
//                     <Transition.Child
//                         as={Fragment}
//                         enter="ease-out duration-300"
//                         enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
//                         enterTo="opacity-100 translate-y-0 sm:scale-100"
//                         leave="ease-in duration-200"
//                         leaveFrom="opacity-100 translate-y-0 sm:scale-100"
//                         leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
//                     >
//                         <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
//                             <Close />
//                             <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
//                                 <div className={`${!center ? 'sm:flex sm:items-start' : ''}`}>
//                                     {type && <Icon type={type} />}
//                                     <div className={`mt-3 text-center ${!center ? 'sm:mt-0 sm:ml-4 sm:text-left' : ''}`}>
//                                         {/* TITLE */}
//                                         {getChildrenByType(children, Title)[0]}
//                                         {getChildrenByType(children, Body)[0]}
//                                     </div>
//                                 </div>
//                             </div>
//                             {getChildrenByType(children, Footer)[0]}
//                         </div>
//                     </Transition.Child>
//                 </div>
//             </Dialog>
//         </Transition.Root>
//     );
// }

// function Backdrop(): JSX.Element {
//     return (
//         <>
//             <Transition.Child
//                 as={Fragment}
//                 enter="ease-out duration-300"
//                 enterFrom="opacity-0"
//                 enterTo="opacity-100"
//                 leave="ease-in duration-200"
//                 leaveFrom="opacity-100"
//                 leaveTo="opacity-0"
//             >
//                 <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
//             </Transition.Child>

//             {/* This element is to trick the browser into centering the modal contents. */}
//             <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
//                 &#8203;
//             </span>
//         </>
//     );
// }

// function Title({ children }: TitleProps): JSX.Element {
//     return (
//         <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
//             {children}
//         </Dialog.Title>
//     );
// }

// function Icon({ type }: IconProps): JSX.Element {
//     return <div className={`${styles.icon[type]} ${styles.icon.base}`}>{icons[type]}</div>;
// }

// function Body({ children }: BodyProps): JSX.Element {
//     return (
//         <div className="mt-2">
//             <p className="text-sm text-gray-500">{children}</p>
//         </div>
//     );
// }

// function Close(): JSX.Element {
//     return (
//         <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
//             <button
//                 type="button"
//                 className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
//                 onClick={(): void => undefined}
//             >
//                 <span className="sr-only">Close</span>
//                 <XIcon className="h-6 w-6" aria-hidden="true" />
//             </button>
//         </div>
//     );
// }

// function Footer({ children }: FooterProps): JSX.Element {
//     const _children = getChildrenByType(children, Button);

//     return (
//         <div className="bg-gray-50 px-4 py-3 sm:px-6 flex flex-row-reverse">
//             {_children[0] && <span className="ml-3 w-auto">{_children[0]}</span>}
//             {_children[1] && <span className="ml-3 w-auto">{_children[1]}</span>}
//         </div>
//     );
// }

// Modal.Title = Title;
// Modal.Body = Body;
// Modal.Footer = Footer;

// export default Modal;
